import { IApplicationState } from '../../../types/redux';

export const selectIsRegionsModalShown = (state: IApplicationState) => state.config.regionsShown;
